export default {
  SET_EXPORT_CONVERSIONS_ERROR: 'SET_EXPORT_CONVERSIONS_ERROR',
  SET_EXPORT_CONVERSIONS_BREAKDOWN_ERROR: 'SET_EXPORT_CONVERSIONS_BREAKDOWN_ERROR',
  SET_IS_EXPORT_CONVERSIONS_LOADING: 'SET_IS_EXPORT_CONVERSIONS_LOADING',
  SET_IS_EXPORT_CONVERSIONS_BREAKDOWN_LOADING: 'SET_IS_EXPORT_CONVERSIONS_BREAKDOWN_LOADING',
};
